import React from "react";
import PlanoExec from '../assets/plano_exec.png'
import PlanoFam from '../assets/plano_familiar.png'
import PlanoPass from '../assets/plano_passadoria.png'

const Planos = () => {
  return (
    <div className="w-full h-fit bg-white dark:bg-white">
      <div className="max-w-[1240px] min-w-[320px] h-full mx-auto">
        
        <div className="flex items-center pt-5">
          <h1 className="font-bold mx-auto mb-2 text-[#292b53] text-3xl sm:text-4xl">
            Conheça os nossos planos
          </h1>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 mx-auto align-center items-center place-items-center p-2">
          {/* min-w-[213px] max-w-[320px]  */}
          <img className="w-[360px] m-1 border rounded-xl border-[rgb(97,198,44)]" alt="/" src={PlanoExec}></img>
          <img className="w-[360px] m-1 border rounded-xl border-[rgb(97,198,44)]" alt="/" src={PlanoFam}></img>
          <img className="w-[360px] m-1 border rounded-xl border-[rgb(97,198,44)]" alt="/" src={PlanoPass}></img>
        </div>
        
        <div className="flex justify-center items-center mt-1 pb-5">
          <button className="w-[300px] h-[50px] border border-[rgb(97,198,44)] rounded-xl border-3 mx-auto text-xl
            hover:text-black hover:bg-[rgb(97,198,44)]  hover:scale-110 duration-150">
            <a 
              href="https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0"
              onClick={(e) => {
                e.preventDefault();
                window.gtag_report_conversion("https://api.whatsapp.com/send/?phone=5541992636949&text=Ol%C3%A1%21+Vim+do+Google+e+gostaria+de+tirar+d%C3%BAvidas.&type=phone_number&app_absent=0");
              }}
            >
              Faça um orçamento
            </a>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Planos;